export const SET_ORG_FEEDS = 'SET_ORG_FEEDS';
export const SET_PERSONAL_FEEDS = 'SET_PERSONAL_FEEDS';
export const FEED_OPERATION = 'FEED_OPERATION';
export const ADD_FEED_TO_ORG = 'ADD_FEED_TO_ORG';
export const ADD_FEED_TO_PERSONAL = 'ADD_FEED_TO_PERSONAL';
export const DELETE_PERSONAL_FEED = 'DELETE_PERSONAL_FEED';
export const DELETE_ORG_FEED = 'DELETE_ORG_FEED';
export const ADD_FEED = 'ADD_FEED';
export const UPDATE_FEED = 'UPDATE_FEED';
